module.exports = __webpack_public_path__ + "img/trade-icon.549201fe.svg";